var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { licenseCheckLatestStatusEntityName, verifyCredentialsBulkActionType, } from '../../../../../backend/features/credentialing-verification/shared';
import { useCredentialVerificationDetailsTable } from '../../../../../ui/features/credentialing-verification/hooks/useCredentialVerificationDetailsTable';
import { useManualCredentialVerificationExpiringOnlyFilter } from '../../../../../ui/features/credentialing-verification/hooks/useManualCredentialVerificationExpiringOnlyFilter';
import { mapLicenseCheckLatestStatusToAccountFilter } from '../../../../../ui/features/credentialing-verification/utils/mapLicenseCheckLatestStatusToAccountFilter';
import { useCredentialingTranslation } from '../../../../../ui/hooks';
import { CredentialingContext } from '../../../../../ui/providers/credentialing-context';
import { userCanMessageNonMembers } from '@juvare/alert-ui/backend/features/permissions/shared';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { ModalSlideout } from '@juvare/common-web-ui/ModalSlideout';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useGroupStorage } from '@juvare/contact-management/AppClients';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { allowCreateGroup, requireAnyOrgPermission, requireAnySystemPermission, } from '@juvare/contact-management/backend/features/permissions/shared';
import { useResolvedAccountFilter, useResolvedAdvancedSearchItems } from '@juvare/contact-management/ui/features/accounts/hooks';
import { handleAddToExistingGroup as cmHandleAddToExistingGroup, handleAddToNewGroup as cmHandleAddToNewGroup, handleAddToOrganization as cmHandleAddToOrganization, } from '@juvare/contact-management/ui/features/organizations/components/OrganizationsPanel/utils';
import { useContactManagementTranslation } from '@juvare/contact-management/ui/hooks/useContactManagementTranslation';
import { beginExport } from '@juvare/platform-sdk-react/ui/components/EntityTable/entityExport';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useExportClient, useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import DomainAddOutlinedIcon from '@mui/icons-material/DomainAddOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Box, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { useLicenseCheckLatestStatusFilterConfig } from '../../hooks/useLicenseCheckLatestStatusFilterConfig';
import { mapLicenseCheckLatestStatusFilter } from '../../utils/mapLicenseCheckLatestStatusFilter';
import { showNotificationDialogWithRecipients } from '../../utils/showNotificationDialogWithRecipients';
const getFilterForBulkAction = (selectedRowIds, entityFilter) => {
    if (selectedRowIds && selectedRowIds.length > 0) {
        return [{ id: selectedRowIds, op: 'in' }];
    }
    return entityFilter;
};
export const CredentialVerificationDetails = ({ userDisplayName, reviewProfileTabName }) => {
    var _a, _b, _c, _d;
    const { t } = useCredentialingTranslation();
    const { t: tContactManagement } = useContactManagementTranslation();
    const { personId, onPersonSelect, onPersonReset, personDetailsComponent: PersonDetailsComponent, } = React.useContext(CredentialingContext);
    const [searchParams] = useSearchParams();
    const exportClient = useExportClient();
    const groupStorageClient = useGroupStorage();
    const settings = useSelector(getSettings);
    const userState = useSelector(getUserState);
    const filterConfig = useLicenseCheckLatestStatusFilterConfig(userDisplayName);
    const licenseCheckLatestStatusStorage = useStorageClient(licenseCheckLatestStatusEntityName);
    const { canEnableExpiringOnlyFilter, expiringOnlyFilter, isExpiringOnlyFilterChecked, handleShowExpiringOnlyFilterChange } = useManualCredentialVerificationExpiringOnlyFilter();
    const { dataTableProps, filtersBarProps, clearActiveRow, appliedFilterData, reload } = useCredentialVerificationDetailsTable({
        expiringOnlyFilter,
        reviewProfileTabName,
    });
    const advancedSearchItems = useResolvedAdvancedSearchItems();
    const appliedAccountFilterData = useResolvedAccountFilter({
        filterData: appliedFilterData,
        advancedSearchItems: advancedSearchItems,
    });
    const appliedFilter = mapLicenseCheckLatestStatusFilter(userState, appliedFilterData, expiringOnlyFilter, (_a = appliedAccountFilterData === null || appliedAccountFilterData === void 0 ? void 0 : appliedAccountFilterData.data) !== null && _a !== void 0 ? _a : []);
    const appliedAccountFilter = mapLicenseCheckLatestStatusToAccountFilter(userState, appliedFilterData, expiringOnlyFilter, (_b = appliedAccountFilterData.data) !== null && _b !== void 0 ? _b : []);
    const bulkActionLatestLicenseCheckStatusFilter = getFilterForBulkAction(dataTableProps.selectedRowIds, appliedFilter);
    const bulkActionAccountFilter = ((_c = dataTableProps.selectedRowIds) === null || _c === void 0 ? void 0 : _c.length)
        ? [
            {
                op: 'in',
                idSubFilter: {
                    entity: licenseCheckLatestStatusEntityName,
                    column: 'personId',
                    filter: [
                        {
                            op: 'in',
                            id: dataTableProps.selectedRowIds,
                        },
                    ],
                },
            },
        ]
        : appliedAccountFilter;
    const licenseCheckLatestStatusOrderBy = dataTableProps.sortColumnKey
        ? [
            {
                column: dataTableProps.sortColumnKey,
                desc: dataTableProps.sortColumnDesc,
            },
        ]
        : undefined;
    /**
     * Needed to deselect all rows when expiringOnlyFilter value changes
     * NOTE: Do not add `dataTableProps` to dependencies to prevent unwanted row deselection
     * */
    React.useEffect(() => {
        var _a;
        (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expiringOnlyFilter]);
    const id = searchParams.get('id');
    React.useEffect(() => {
        if (!personId && id) {
            licenseCheckLatestStatusStorage
                .get(id)
                .then((entity) => onPersonSelect(entity.columns.personId))
                .catch(() => {
                // Ignore
            });
        }
    }, [id, licenseCheckLatestStatusStorage, onPersonSelect, personId]);
    const handlePersonDetailsSlideoutClose = () => {
        clearActiveRow();
        onPersonReset();
    };
    const handleBulkNotify = () => {
        showNotificationDialogWithRecipients(t, {
            includeNonMembers: userCanMessageNonMembers(userState),
            accounts: [],
            accountsFilter: bulkActionAccountFilter,
            organizations: [],
            groups: [],
        });
    };
    const handleBulkVerifyCredentials = () => {
        launchBulkAction({
            type: verifyCredentialsBulkActionType,
            title: t('table.credentialingVerification.actions.verifyCredentialsDialog.bulkActionTitle'),
            params: {
                requestedBy: userDisplayName,
                filter: bulkActionAccountFilter,
            },
            onClose: () => {
                var _a;
                (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                reload();
            },
        });
    };
    const getAccountIdsByFilter = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield licenseCheckLatestStatusStorage.list({ filter });
            const accountIds = response.rows.map(({ columns }) => {
                return columns.personId;
            });
            return Array.from(new Set(accountIds));
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
        return [];
    });
    const handleReloadTable = () => {
        var _a;
        (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
        reload();
    };
    const handleAddToNewGroup = () => __awaiter(void 0, void 0, void 0, function* () {
        const accountIds = yield getAccountIdsByFilter(bulkActionLatestLicenseCheckStatusFilter);
        if (!accountIds.length) {
            return;
        }
        cmHandleAddToNewGroup({
            accountIds,
            t: tContactManagement,
            groupStorageClient,
            totalFilteredAccounts: accountIds.length,
            appliedStorageFilters: [{ id: accountIds, op: 'in' }],
            onClose: handleReloadTable,
        });
    });
    const handleAddToExistingGroup = () => __awaiter(void 0, void 0, void 0, function* () {
        const accountIds = yield getAccountIdsByFilter(bulkActionLatestLicenseCheckStatusFilter);
        if (!accountIds.length) {
            return;
        }
        cmHandleAddToExistingGroup({
            accountIds,
            t: tContactManagement,
            appliedStorageFilters: [{ id: accountIds, op: 'in' }],
            onClose: handleReloadTable,
        });
    });
    const handleAddToOrganization = () => __awaiter(void 0, void 0, void 0, function* () {
        const accountIds = yield getAccountIdsByFilter(bulkActionLatestLicenseCheckStatusFilter);
        if (!accountIds.length) {
            return;
        }
        cmHandleAddToOrganization({
            accountIds,
            t: tContactManagement,
            totalFilteredAccounts: accountIds.length,
            appliedStorageFilters: [{ id: accountIds, op: 'in' }],
            onConfirm: handleReloadTable,
        });
    });
    const handleExport = ({ exportAll }) => () => {
        const defaultFilter = {
            column: 'personId',
            op: 'in',
            subFilter: {
                entity: accountEntityName,
                filter: [
                    {
                        column: 'systemStatus',
                        op: '=',
                        value: 'active',
                    },
                ],
            },
        };
        beginExport(exportClient, licenseCheckLatestStatusEntityName, 'csv', !exportAll && (dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds) && (dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds.length) > 0
            ? dataTableProps.selectedRowIds
            : undefined, exportAll ? [defaultFilter] : appliedFilter, licenseCheckLatestStatusOrderBy);
    };
    return (React.createElement(Box, { p: 4 },
        React.createElement(DataTable, Object.assign({}, dataTableProps, { filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), tableSx: { tableLayout: 'fixed' }, globalActions: [
                {
                    icon: React.createElement(FileUploadOutlinedIcon, null),
                    label: t('table.credentialingVerification.actions.exportAll'),
                    onClick: handleExport({ exportAll: true }),
                    'data-test': 'export-global-action-button',
                },
            ], localActions: [
                ...(allowCreateGroup(userState)
                    ? [
                        {
                            icon: React.createElement(GroupAddOutlinedIcon, null),
                            label: tContactManagement('panels.accounts.addToGroup'),
                            'data-test': 'add-to-group-button',
                            disabled: (!dataTableProps.selectedRowIds || ((_d = dataTableProps.selectedRowIds) === null || _d === void 0 ? void 0 : _d.length) === 0) &&
                                !dataTableProps.filteredRowCount,
                            menuItems: [
                                {
                                    label: tContactManagement('panels.accounts.newGroup'),
                                    onClick: handleAddToNewGroup,
                                    'data-test': 'new-group-button',
                                },
                                {
                                    label: tContactManagement('panels.accounts.addToExistingGroup'),
                                    onClick: handleAddToExistingGroup,
                                    'data-test': 'existing-group-button',
                                },
                            ],
                        },
                    ]
                    : []),
                ...(settings.organizationsEnabled &&
                    (requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members'))
                    ? [
                        {
                            label: tContactManagement('panels.accounts.addToOrganization'),
                            icon: React.createElement(DomainAddOutlinedIcon, null),
                            'data-test': 'toolbar-add-to-organization-button',
                            onClick: handleAddToOrganization,
                        },
                    ]
                    : []),
                {
                    icon: React.createElement(FileUploadOutlinedIcon, null),
                    label: t('table.credentialingVerification.actions.export'),
                    onClick: handleExport({ exportAll: false }),
                    'data-test': 'export-local-action-button',
                },
                {
                    icon: React.createElement(SendOutlinedIcon, null),
                    label: t('table.credentialingVerification.actions.notify'),
                    onClick: handleBulkNotify,
                    'data-test': 'notify-local-action-button',
                },
                {
                    icon: React.createElement(ContentPasteSearchIcon, null),
                    label: t('table.credentialingVerification.actions.verifyCredentials'),
                    onClick: () => {
                        showConfirmDialog({
                            title: t('table.credentialingVerification.actions.verifyCredentialsDialog.title'),
                            content: t('table.credentialingVerification.actions.verifyCredentialsDialog.content'),
                            onConfirm: handleBulkVerifyCredentials,
                            confirmLabel: t('table.credentialingVerification.actions.verifyCredentialsDialog.confirmLabel'),
                        });
                    },
                    'data-test': 'verify-credentials-local-action-button',
                },
            ], customHeaderElement: canEnableExpiringOnlyFilter && (React.createElement(FormControlLabel, { sx: { mt: -2, mb: -2 }, label: t('credentialVerificationsPage.showExpiringOnly'), control: React.createElement(Switch, { checked: isExpiringOnlyFilterChecked, onChange: handleShowExpiringOnlyFilterChange }) })) })),
        personId && (React.createElement(ModalSlideout, { open: !!personId, onClose: handlePersonDetailsSlideoutClose, "data-test": 'person-details-slideout' }, personId && PersonDetailsComponent && React.createElement(PersonDetailsComponent, { accountId: personId })))));
};
